import { createContext, useContext } from 'react'
import type { CreateModelState, CreateModelAction, ValidationWarning, CostEstimate } from './types'
import type { TrainingModelDef } from './types'

export interface CreateModelContextValue {
  state: CreateModelState
  dispatch: React.Dispatch<CreateModelAction>
  // Derived values
  validationWarnings: ValidationWarning[]
  estimatedCost: CostEstimate | null
  canSubmit: boolean
  selectedTrainer: TrainingModelDef | null
}

export const CreateModelContext = createContext<CreateModelContextValue | null>(null)

export function useCreateModel(): CreateModelContextValue {
  const ctx = useContext(CreateModelContext)
  if (!ctx) throw new Error('useCreateModel must be used within CreateModelContext')
  return ctx
}
